import React from 'react';
import { ProtectedPage } from '../../layout/ProtectedPage';
import RoleHomeDashboard from '../../componen/RoleHomeDashboard';
import { DashboardBupatiPages } from '../bupatiDanKepalaDinasPages.jsx/DashboardBupatiPages';

const withRoleDashboard = (roleKey) => function RoleDashboardPage() {
  return (
    <ProtectedPage>
      <RoleHomeDashboard roleKey={roleKey} />
    </ProtectedPage>
  );
};

export const BupatiDashboardPages = function BupatiDashboardPage() {
  return (
    <ProtectedPage>
      <DashboardBupatiPages />
    </ProtectedPage>
  );
};

export const KadisDashboardPages = function KadisDashboardPage() {
  return (
    <ProtectedPage>
      <DashboardBupatiPages />
    </ProtectedPage>
  );
};

export const KepalaDinasDashboardPages = function KepalaDinasDashboardPage() {
  return (
    <ProtectedPage>
      <DashboardBupatiPages />
    </ProtectedPage>
  );
};

export const AgrDashboardPages = withRoleDashboard('AGR');
export const TflDashboardPages = withRoleDashboard('TFL');
export const FasilitatorDashboardPages = withRoleDashboard('fasilitator');
export const SupplierDashboardPages = withRoleDashboard('Supplier Penyedia');
export const PpkDashboardPages = withRoleDashboard('PPK');
export const KabidDashboardPages = withRoleDashboard('Kabid');